<!--
  Composant 'div' en mode flex vertical
    - Le slot par défaut permet d'insérer verticalement des éléments
-->
<template>
  <div style="display: flex; flex-direction: column; justify-content: flex-start; align-items: center; align-content: flex-start; flex-wrap: wrap;">
    <slot></slot>
  </div>
</template>

<script>
export default {

}
</script>

<style>

</style>